import { createBrowserHistory } from "history";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import sidebarReducer from "../Common/Slices/SidebarSlice";
import menuReducer from "../Common/Slices/MenuSlice";
import dashboardReducer from "../Common/Slices/DashboardSlice";
import paramsReducer from "../Common/Slices/ParamSlice";
import authReducer from "../Core/Slice";
import datatypesReducer from "../Common/Slices/DataTypesSlice";
import eventsReducer from "../Events/Slice";
import customersReducer from "../Customers/Slice";
import selecteddateReducer from "../Common/Slices/SelectedDateSlice";
import optionsReducer from "../Common/Slices/optionSlice";
import chartoptionsReducer from "../Common/Slices/ChartOptionsSlice";
import customerListReducer from "../Search/Slice";
import settingsReducer from "../Settings/Slice";
import searchReducer from "../Search/SearchSlice";
import pstReducer from "../Search/PSTSlice";
import dialogReducer from "../Common/Slices/DialogSlice";

import serviceReportReducer from "../Events/SRParamSlice";
import jiraReportReducer from "../JiraReports/JiraParamSlice";

import { listenerMiddleware } from "./listenerMiddleware";

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  dashboard: dashboardReducer,
  params: paramsReducer,
  menu: menuReducer,
  auth: authReducer,
  events: eventsReducer,
  customers: customersReducer,
  datatypes: datatypesReducer,
  selecteddate: selecteddateReducer,
  options: optionsReducer,
  chartoptions: chartoptionsReducer,
  customerList: customerListReducer,
  settings: settingsReducer,
  search: searchReducer,
  jiraParams: jiraReportReducer,
  serviceReportParams: serviceReportReducer,
  pstCustomerList: pstReducer,
  dialog: dialogReducer,
  //widgets:widgetsReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
